<template>
  <div>
    <v-btn
      color="primary"
      small
      class="mb-3"
      :disabled="showSignaturePad"
      @click="handlePrint"
    >
      <v-icon>
        mdi-printer
      </v-icon>
      Print
    </v-btn>
    <div
      id="printSection"
      ref="printSection"
    >
      <center style="margin-bottom: 10px;">
        <h3>教練聯盟</h3>
        <h3>Asian Alliance Limited</h3>
      </center>
      <v-row>
        <v-col>
          <v-row
            v-for="config in studentReviewConfig"
            :key="config.prop"
          >
            <v-col class="font-weight-bold">
              {{ config.label }}
            </v-col>
            <v-col>
              {{ config.formatter?config.formatter(studentData[config.prop]):studentData[config.prop] }}
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-row
            v-for="config in orderReviewConfig"
            :key="config.prop"
          >
            <v-col class="font-weight-bold">
              {{ config.label }}
            </v-col>
            <v-col>
              {{ config.formatter?config.formatter(orderInfo[config.prop]):orderInfo[config.prop] }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div>
        <h5>Terms & Conditions</h5>
        <div
          class="terms-condition"
          v-html="termsCondition"
        ></div>
      </div>
      <v-row id="VueSignaturePad">
        <v-col
          md="6"
          lg="6"
          ex-lg="6"
          cols="12"
        >
          <section v-if="showSignaturePad">
            <VueSignaturePad
              ref="signaturePad"
              :custom-style="signatureStyle"
              height="200px"
            />
            <div>
              <v-btn
                text
                color="primary"
                @click="save"
              >
                Save
              </v-btn>
              <v-btn
                text
                color="secondary"
                @click="undo"
              >
                Undo
              </v-btn>
            </div>
          </section>
          <section
            v-if="!showSignaturePad"
          >
            <v-img
              :height="200"
              width="50%"
              contain
              aspect-ratio="16/9"
              :src="signatureImageSrc"
            ></v-img>
            <v-btn
              class="not-print"
              color="secondary"
              @click="handleRetry"
            >
              Retry
            </v-btn>
          </section>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-row>
            <v-col>{{ studentData.fullName }}</v-col>
          </v-row>
          <v-row>
            <v-col>{{ moment().format('yyyy-MM-DD') }}</v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-row>
            <v-col><span class="font-weight-bold">Prepared by</span></v-col>
          </v-row>
          <v-row>
            <v-col><span class="font-weight-bold">{{ orderInfo.salesmanName }}</span></v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, computed, nextTick } from 'vue'
import moment from '@/utils/moment'
import { useStore } from '@/store'
import { GetLatestRecord } from '@/api/termsCondition'
import { formatDate } from '@/utils/helper'

const signatureImageSrc = ref('https://cdn.vuetifyjs.com/images/parallax/material.jpg')
const showSignaturePad = ref(true)

const printSection = ref(null)

const emit = defineEmits(['toggleBtn', 'print'])
function handlePrint() {
  emit('print', signatureImageSrc.value)

  return true
}

function printOrder() {
  // Get HTML to print from element
  let prtHtml = `<section class='print-window px-5 pt-5 pb-5'>${printSection.value.innerHTML}</section>`
  console.log('prtHtml', prtHtml)
  if (prtHtml.indexOf('<button type="button" class="not-print v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default secondary"><span class="v-btn__content"> Retry </span></button>') > 0) {
    console.log('has button')
    prtHtml = prtHtml.replace('<button type="button" class="not-print v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default secondary"><span class="v-btn__content"> Retry </span></button>', '')
  }
  console.log('replaced prtHtml', prtHtml)

  // Get all stylesheets HTML
  let stylesHtml = ''
  for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
    stylesHtml += node.outerHTML
  }

  // Open the print window
  const printCnt = `<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`

  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(printCnt)
  } else {
    const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
    console.log('printCnt', printCnt)
    WinPrint.document.write(printCnt)
    setTimeout(() => {
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    }, 500)
  }
}

const signatureStyle = ref({
  border: 'black 1px solid ',
  borderRadius: '25px',
})

const store = useStore()
console.log('store', store)

const orderInfo = computed(() => ({ ...store.getters.orderInfo }))

// const salemanName = computed(() => {
//   if (orderInfo.value != null && orderInfo.value.salesmanName) {
//     return orderInfo.value.salesmanName
//   }

//   return '[Salesman]'
// })

const studentData = computed(() => ({ ...store.getters.orderInfo.userRecord }))
const studentReviewConfig = ref([
  {
    label: 'Membership No',
    prop: 'userNo',
  },
  {
    label: 'Membership Name',
    prop: 'fullName',
  },
  {
    label: 'Gender',
    prop: 'gender',
    formatter(value) {
      if (value === 'M') {
        return 'Male'
      }

      return 'Female'
    },
  },
  {
    label: 'HK ID',
    prop: 'hkid',
  },
  {
    label: 'Telephone',
    prop: 'mobileNo',
  },
  {
    label: 'Email',
    prop: 'email',
  },
])
const orderReviewConfig = ref([
  {
    label: 'Order No',
    prop: 'orderNo',
  },
  {
    label: 'Course',
    prop: 'courseID',
    formatter(value) {
      const target = store.getters.course.filter(record => record.id === value)
      if (target.length > 0) {
        return target[0].courseName
      }

      return value
    },
  },
  {
    label: 'Program',
    prop: 'sessionTotal',
  },
  {
    label: 'Total Amount',
    prop: 'totalAmount',
  },
  {
    label: 'Effective Date',
    prop: 'effectiveDate',
    formatter(value) {
      if (value) {
        return formatDate(value)
      }

      return formatDate(new Date())
    },
  },
  {
    label: 'Expiry Date',
    prop: 'expiryDate',
    formatter(value) {
      if (value) {
        return formatDate(value)
      }

      return formatDate(new Date())
    },
  },
  {
    label: 'Promotion',
    prop: 'promotionID',
    formatter(value) {
      const target = store.getters.promotionItems.filter(record => record.id === value)
      if (target.length > 0) {
        return target[0].fullName
      }

      return ''
    },
  },
])
const termsCondition = ref('Terms and Conditions is not available. Please contact website administrator.')
GetLatestRecord().then(response => {
  console.log('termsCondition', response.data.record)
  if (response.data.record) {
    termsCondition.value = response.data.record.content
  }
})

const signaturePad = ref(null)

// onMounted(() => {
//   signaturePad.value.resizeCanvas()
// })

function resizeCanvas() {
  signaturePad.value.resizeCanvas()
}

defineExpose({ resizeCanvas, showSignaturePad, printOrder })

function undo() {
  signaturePad.value.undoSignature()
}
function handleRetry() {
  showSignaturePad.value = true
  emit('toggleBtn', true)
}
function save() {
  const { isEmpty, data } = signaturePad.value.saveSignature()
  console.log(isEmpty)
  console.log(data)
  if (!isEmpty) {
    signatureImageSrc.value = data
    showSignaturePad.value = false
    emit('toggleBtn', false)
  }
}
</script>
<style >
.terms-condition p{
  margin-bottom: 3px !important;
}
@media print {
    /* styles here */
  .not-print{
    display: none;
  }
  body {
    /* display: block !important; */
    -webkit-print-color-adjust:exact;
    print-color-adjust:exact;
  }
}
.print-window .not-print{
  display: none;
}
</style>
